<template lang="pug">
  main
    NavBarSca
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Reportes TPA

        .columns.has-text-centered
          .column.is-12
            .tabs
              ul
                li(:class="{ 'is-active': tabsel == 'repDiarios' }" @click="cambiarTab('repDiarios')")
                  a
                    | &nbspReportes Diarios
                li(:class="{ 'is-active': tabsel == 'repMensual' }" @click="cambiarTab('repMensual')")
                  a
                    | &nbspReportes Mensuales
                li(v-show="ver_sca_rdcSubgrupos" :class="{ 'is-active': tabsel == 'repSubgrupos' }" @click="cambiarTab('repSubgrupos')")
                  a
                    | &nbspReportes Subgrupos
        .columns(v-show="verTabRDiario")
          .column.is-12-desktop.is-12-tablet.has-text-centered
            .card
              .card-content
                .columns.is-vcentered
                  .column.is-3-desktop.is-3-tablet.has-text-centered
                    | Seleccione una fecha para los Reportes:
                    .field
                      .control
                        flat-pickr(
                          v-model='date'
                          :config="config"
                          class="input"
                        )
        .columns(v-show="verReportesDiarios")
          .column.is-4
            a.button.is-danger.is-rounded.is-small(:href="lRep_DComp" target="_blank")
              span.icon
                i.fas.fa-print
            span
              | &nbsp {{ textRep_DComp }}
              .column.is-4
            a.button.is-danger.is-rounded.is-small(:href="lRep_DCompN" target="_blank")
              span.icon
                i.fas.fa-print
            span
              | &nbsp {{ textRep_DCompN }}

          .column.is-4
            a.button.is-danger.is-rounded.is-small(:href="lRep_DCompania" target="_blank")
              span.icon
                i.fas.fa-print

            | &nbsp {{ textRep_DCompania }}
            .column.is-4
            a.button.is-danger.is-rounded.is-small(:href="lRep_DCompaniaN" target="_blank")
              span.icon
                i.fas.fa-print
            | &nbsp {{ textRep_DCompaniaN }}


        .columns(v-show="verReportesDiarios")
          .column.is-4
            a.button.is-success.is-rounded.is-small(@click="generarRIF('normal')")
              span.icon
                i.fas.fa-print
            | &nbsp {{ txtRIF_excel }}
          .column.is-4
            a.button.is-success.is-rounded.is-small(:href="lRep_DCompaniaExcel" target="_blank")
              span.icon
                i.fas.fa-print
            | &nbsp {{ textRep_DCompaniaExcel }}
        .columns(v-show="verReportesDiarios && ver_sca_rdcMov")
          .column.is-4
            a.button.is-success.is-rounded.is-small(@click="generarRIF('mov')")
              span.icon
                i.fas.fa-print
            | &nbsp {{ txtRIF_excel_mov }}
          .column.is-4
            a.button.is-success.is-rounded.is-small(:href="lRep_DSellos" target="_blank")
              span.icon
                i.fas.fa-print
            | &nbsp {{ textRep_DSellos }}
          .column.is-4
            a.button.is-success.is-rounded.is-small(@click="generarRDCmensualVol('diario')")
              span.icon
                i.fas.fa-print
            | &nbsp {{ txtRDC_diario_excel_mov }}

        .columns(v-show="verReportesDiarios")
          .column.is-4
            a.button.is-danger.is-rounded.is-small(:href="lRep_D5" target="_blank")
              span.icon
                i.fas.fa-print
            | &nbsp {{ textRep_D5 }}
            .column.is-4
            a.button.is-danger.is-rounded.is-small(:href="lRep_D5N" target="_blank")
              span.icon
                i.fas.fa-print
            | &nbsp {{ textRep_D5N }}

        .columns(v-show="verTabRMensual")
          .column.is-12-desktop.is-12-tablet.has-text-centered
            .card
              .card-content
                .columns.is-vcentered
                  .column.is-3-desktop.is-3-tablet.has-text-centered
                    | Seleccione una Mes para los Reportes:
                    .field
                      .control
                        flat-pickr(
                          v-model='dateMensual'
                          :config="configMensual"
                          class="input"
                        )
        .columns(v-show="verReportesMensual")
          .column.is-4
            a.button.is-danger.is-rounded.is-small(:href="linkReporteMensual" target="_blank")
              span.icon
                i.fas.fa-print
            | &nbsp {{ textReporteMensual }}
          .column.is-4
            a.button.is-success.is-rounded.is-small(:href="linkReporteMensualE" target="_blank")
              span.icon
                i.fas.fa-print
            | &nbsp {{ textReporteMensual }}
        .columns(v-show="verReportesMensual")
          .column.is-4
            a.button.is-success.is-rounded.is-small(@click="generarRIFmensual('normal')")
              span.icon
                i.fas.fa-print
            | &nbsp {{ txtRIF_mensual_excel }}
          .column.is-4
            a.button.is-success.is-rounded.is-small(@click="generarRIFmensual('mov')")
              span.icon
                i.fas.fa-print
            | &nbsp {{ txtRIF_mensual_excel_mov }}
          .column.is-4
            a.button.is-success.is-rounded.is-small(@click="generarRDCmensualVol('mensual')")
              span.icon
                i.fas.fa-print
            | &nbsp {{ txtRDC_mensual_excel_mov }}
        .columns(v-show="verTabRSubgrupos")
          .column.is-12-desktop.is-12-tablet.has-text-centered
            .card
              .card-content
                .columns.is-vcentered
                  .column.is-3-desktop.is-3-tablet.has-text-centered
                    | Seleccione una fecha para los Reportes:
                    .field
                      .control
                        flat-pickr(
                          v-model='date'
                          :config="config"
                          class="input"
                        )
        .columns(v-show="verReportesSubgrupos")
          .column.is-4
            .columns(v-for="c in companias" :key="c.id")
              .column
                a.button.is-success.is-rounded.is-small( @click="generarReporteCompania(c.id)")
                  span.icon
                    i.fas.fa-print
                | &nbsp {{ c.nombre }}
          .column.is-4
            .columns(v-for="s in subgrupos" :key="s.id")
              .column
                a.button.is-success.is-rounded.is-small( @click="generarReporteSubgrupo(s.id)")
                  span.icon
                    i.fas.fa-print
                | &nbsp {{ s.nombre }} - {{ s.compania }}

</template>

<script>
  import NavBarSca from '@/components/sca_Componentes/layout/tpa/NavBarSca.vue'
  import Loader from '@/components/shared/Loader.vue'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import sca_tuxpanServices from '../../../services/sca/tpa'

  export default {
    name: 'Reportes_TPA',
    components: { NavBarSca, Loader, flatPickr },
    data() {
      return {
        isLoading: true,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only
        },
        dateMensual: '',
        configMensual: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only
        },
        date: '',
        lRep_DComp: '',
        lRep_DCompN: '',
        textRep_DComp: '',
        textRep_DCompN: '',
        lRep_D5: '',
        lRep_D5N: '',
        textRep_D5: '',
        textRep_D5N: '',
        lRIF_excel: '',
        txtRIF_excel: '',
        txtRIF_mensual_excel: '',
        txtRIF_excel_mov: '',
        txtRIF_mensual_excel_mov:'',
        txtRDC_mensual_excel_mov:'',
        txtRDC_diario_excel_mov: '',
        lRep_DCompania: '',
        lRep_DCompaniaN: '',
        textRep_DCompania: '',
        textRep_DCompaniaN: '',
        lRep_DCompaniaExcel: '',
        textRep_DCompaniaExcel: '',
        lRep_DSellos: '',
        textRep_DSellos: '',
        lRep_DGrupo: '',
        textRep_DGrupo: '',
        lRep_DPemex: '',
        textRep_DPemex: '',
        lRep_DPemexExcel: '',
        textRep_DPemexExcel: '',
        linkReporteMensual: '',
        linkReporteMensualE: '',
        textReporteMensual: '',
        verReportesDiarios: false,
        verReportesMensual: false,
        verReportesSubgrupos: false,
        verTabRDiario: true,
        verTabRMensual: false,
        verTabRSubgrupos: false,
        tabsel: 'repDiarios',
        configuracion: {},
        ver_sca_pemexReportes: false,
        ver_sca_rdcMov: false,
        ver_sca_rdcSubgrupos: false,
        companias: [],
        subgrupos: [],
      }
    },
    watch: {
      date() {
        switch (this.tabsel) {
          case 'repDiarios':
            this.generarReportes()
            break
          case 'repMensual':
            this.generarReporteMensual()
            break
          case 'repSubgrupos':
            this.generarReporteSubgrupos()
            break
        }
      },
      dateMensual() {
        switch (this.tabsel) {
          case 'repDiarios':
            this.generarReportes()
            break
          case 'repMensual':
            this.generarReporteMensual()
            break
          case 'repSubgrupos':
            this.generarReporteSubgrupos()
            break
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.date = moment().format('YYYY-MM-DD')
        this.dateMensual = moment().format('YYYY-MM')
        this.obtenerConfiguracion()
      },

      obtenerConfiguracion () {
        this.configuracion = {}
        sca_tuxpanServices.obtenerConfiguracion()
          .then( data => {
            this.configuracion = this.convertirConfiguracion(data[0])
            this.ver_sca_pemexReportes = this.configuracion.sca_pemexReportes
            this.ver_sca_rdcMov = this.configuracion.sca_rdcMov
            this.ver_sca_rdcSubgrupos = this.configuracion.sca_rdcSubgrupos
            if (this.ver_sca_rdcSubgrupos) {
              this.generarReporteSubgrupos()
            }
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })

      },

      convertirConfiguracion(config) {
        return {
          ...config,
          sca_pesoNeto: config.sca_pesoNeto === '1' ? true : false,
          sca_pemexReportes: config.sca_pemexReportes === '1' ? true : false,
          sca_cargasSCA_Pemex: config.sca_cargasSCA_Pemex === '1' ? true : false,
          sca_rdcMov: config.sca_rdcMov === '1' ? true : false,
          sca_rdcSubgrupos: config.sca_rdcSubgrupos === '1' ? true : false,
        }
      },

      generarReportes () {
        const currentUrl = window.location.hostname

        this.lRep_DComp = `https://${currentUrl}/servidores/reportes/TPA_Documentadas.php?fecha=${this.date}`
        this.textRep_DComp = `${this.date}_Reporte_Diario_Completo`
        this.lRep_DCompN = `https://${currentUrl}/reportes/cargasDiarias_TPA.php?fecha=${this.date}`
        this.textRep_DCompN = `${this.date}_Reporte_Diario_Completo_NUEVO`

        this.lRep_D5 = `https://${currentUrl}/servidores/reportes/TPA_Documentadas5.php?fecha=${this.date}`
        this.textRep_D5 = `${this.date}_Reporte_Vespertino`
        this.lRep_D5N = `https://${currentUrl}/reportes/cargasVespertinas_TPA.php?fecha=${this.date}`
        this.textRep_D5N = `${this.date}_Reporte_Vespertino_NUEVO`
        this.txtRDC_diario_excel_mov = `${this.date}_RDC_TPA_MOVENERGY_Diario_vol`

        this.lRep_DCompania = `https://${currentUrl}/servidores/reportes/TPA_Doc_Comp.php?fecha=${this.date}&tipo=1`
        this.textRep_DCompania = `${this.date}_Reporte_Compañías`
        this.lRep_DCompaniaN = `https://${currentUrl}/reportes/companias_TPA.php?fecha=${this.date}`
        this.textRep_DCompaniaN = `${this.date}_Reporte_Compañías_NUEVO`

        this.lRep_DCompaniaExcel = `https://${currentUrl}/servidores/reportes/TPA_Doc_Comp.php?fecha=${this.date}&tipo=2`
        this.textRep_DCompaniaExcel = `${this.date}_Reporte_Compañías`

        this.txtRIF_excel = `${this.date}_RDC_TPA`
        this.txtRIF_mensual_excel = `${this.dateMensual}_RDC_TPA_Reporte_Mensual`
        this.txtRIF_mensual_excel_mov = `${this.dateMensual}_RDC_TPA_MOVENERGY_mensual`
        this.txtRIF_excel_mov = `${this.date}_RDC_TPA_MOVENERGY`
        this.txtRDC_mensual_excel_mov = `${this.dateMensual}_RDC_TPA_MOVENERGY_mensual_vol`
        this.lRep_DSellos = `https://${currentUrl}/reportesApp/server/excel/Reporte_sellosTPA.php?fecha=${this.date}`
        this.textRep_DSellos = `${this.date}_Reporte_Sellos`

        this.verReportesDiarios = true
        this.verReportesMensual = false
        this.verReportesSubgrupos = false
      },

      cambiarTab(tab) {
          this.tabsel = tab

          switch (tab) {
            case 'repDiarios':
              this.generarReportes()
              this.verTabRDiario = true
              this.verTabRMensual = false
              this.verTabRSubgrupos = false
              this.verReportesDiarios = true
              this.verReportesMensual = false
              this.verReportesSubgrupos = false
              break
            case 'repMensual':
              this.generarReporteMensual()
              this.verTabRDiario = false
              this.verTabRMensual = true
              this.verTabRSubgrupos = false
              this.verReportesDiarios = false
              this.verReportesMensual = true
              this.verReportesSubgrupos = false
              break
            case 'repSubgrupos':
              this.generarReporteSubgrupos()
              this.verTabRDiario = false
              this.verTabRMensual = false
              this.verTabRSubgrupos = true
              this.verReportesDiarios = false
              this.verReportesMensual = false
              this.verReportesSubgrupos = true
              break
          }
      },

      generarRIF (cliente) {
        this.isLoading = true
        sca_tuxpanServices.createExcel_rif(this.date, cliente)
          .then( data => {
            if (data.success) {
              const currentUrl = window.location.hostname
              const link = `https://${currentUrl}/reportesApp/server/excel/generarRIFTPA.php?nameFile=${data.file}`
              open(link, '_blank')
              setTimeout(() => {
                sca_tuxpanServices.borrarArchivo(data.file)
                  .then( dataD => {
                    this.displayToast(dataD.excelBorrado ? 'bubble' : 'tosted-primary', dataD.excelBorrado ? 'Archivo descargado' : 'El archivo no se pudo borrar', dataD.excelBorrado ? 'check' : 'ban', 'OK')
                    this.isLoading = false
                  })
                  .catch(err => {
                    this.displayToast('bubble',`Error2: ${err.message}`, 'ban', 'OK')
                    this.isLoading = false
                  })
              }, 4000)
            } else {
              this.displayToast('bubble',`Error::: ${data.excelBorrado}`, 'ban', 'OK')
            }
          })
          .catch( e => {
            this.displayToast('bubble',`Error1: ${e.message}`, 'ban', 'OK')
            this.isLoading = false
          })
      },

      generarRIFmensual (cliente) {
        this.isLoading = true
        let fechaI = `${this.dateMensual}-01`
        let fechaF = moment(fechaI).endOf('month').format('YYYY-MM-DD')

        sca_tuxpanServices.createExcel_rif_mensual(fechaI,fechaF, cliente)
          .then( data => {
            if (data.success) {
              const currentUrl = window.location.hostname
              const link = `https://${currentUrl}/reportesApp/server/excel/generarRIFTPA.php?nameFile=${data.file}`
              open(link, '_blank')
              setTimeout(() => {
                /* sca_tuxpanServices.borrarArchivo(data.file)
                  .then( dataD => {
                    this.displayToast(dataD.excelBorrado ? 'bubble' : 'tosted-primary', dataD.excelBorrado ? 'Archivo descargado' : 'El archivo no se pudo borrar', dataD.excelBorrado ? 'check' : 'ban', 'OK')
                    this.isLoading = false
                  })
                  .catch(err => {
                    this.displayToast('bubble',`Error2: ${err.message}`, 'ban', 'OK')
                    this.isLoading = false
              }, 4000) */
                  })
            } else {
              this.displayToast('bubble',`Error::: ${data.error}`, 'ban', 'OK')
            }
          })
          .catch( e => {
            this.displayToast('bubble',`Error1: ${e.message}`, 'ban', 'OK')
            this.isLoading = false
          })
      },
      generarRDCmensualVol (reporte) {
        this.isLoading = true
        let fechaI
        if(reporte=='mensual'){
          fechaI = `${this.dateMensual}-01`
        }else{
          fechaI = this.date
        }
        let fechaF = moment(fechaI).endOf('month').format('YYYY-MM-DD')

        sca_tuxpanServices.createExcel_rdc_mensual(fechaI,fechaF, reporte)
          .then( data => {
            console.log(data)
            if (data.success) {
              const currentUrl = 'ducter.com.mx/'//window.location.hostname
              const link = `https://${currentUrl}/reportesApp/server/excel/generarRDCVolumetricos.php?nameFile=${data.file}`
              open(link, '_blank')
            } else {
              this.displayToast('bubble',`Error::: ${data.error}`, 'ban', 'OK')
            }
            this.isLoading = false
          })
          .catch( e => {
            this.displayToast('bubble',`Error1: ${e.message}`, 'ban', 'OK')
            this.isLoading = false
          })
      },
      generarReporteMensual () {
        var currentUrl = window.location.hostname
        let fechaI = `${this.dateMensual}-01`
        let fechaF = moment(fechaI).endOf('month').format('YYYY-MM-DD')
        this.linkReporteMensual = `https://${currentUrl}/servidores/reportes/TPA_EntregaProducto.php?fechaI=${fechaI}&fechaF=${fechaF}&tipo=1`
        this.linkReporteMensualE = `https://${currentUrl}/servidores/reportes/TPA_EntregaProducto.php?fechaI=${fechaI}&fechaF=${fechaF}&tipo=2`

        this.textReporteMensual = `${this.dateMensual}_Reporte_Mensual`
        this.txtRIF_mensual_excel = `${this.dateMensual}_RDC_TPA_Reporte_Mensual`
        this.txtRIF_mensual_excel_mov = `${this.dateMensual}_RDC_TPA_MOVENERGY_mensual`
        this.txtRIF_excel_mov = `${this.date}_RDC_TPA_MOVENERGY`
        this.txtRDC_mensual_excel_mov = `${this.dateMensual}_RDC_TPA_MOVENERGY_mensual_vol`
        this.verReportesMensual = true
        this.verReportesDiarios = false
        this.verReportesSubgrupos = false
      },

      generarReporteSubgrupos () {
        sca_tuxpanServices.obtenerCompaniasDocumentadas(this.date)
          .then( dataCompanias => {
            this.companias = dataCompanias
            sca_tuxpanServices.obtenerSubgruposDocumentados(this.date)
              .then( dataSubgrupos => {
                this.subgrupos = dataSubgrupos
              })
              .catch( error => {
              this.isLoading = false
              this.displayToast('bubble', error.message, 'ban', 'OK')
              })
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble', e.message, 'ban', 'OK')
          })
      },

      generarReporteCompania (compania) {
        const currentUrl = window.location.hostname
        const link = `https://${currentUrl}/reportesApp/server/excel/Reporte_compania.php?fecha=${this.date}&compania=${compania}&u=tpa`
        window.open(link, '_blank')
      },

      generarReporteSubgrupo (subgrupo) {
        const currentUrl = window.location.hostname
        const link = `https://${currentUrl}/reportesApp/server/excel/Reporte_subgrupo.php?fecha=${this.date}&subgrupo=${subgrupo}&u=tpa`
        window.open(link, '_blank')
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: tema,
          position: "bottom-right",
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/Reportes_TPA.vue